export default __webpack_public_path__ + "a9f0a9635659c05b9dbe1f7ede6551f5.png";